import { ArrowLeftRight, CakeSlice, CalendarDays, Plane, Send, TriangleAlert, User } from 'lucide-react';

import { cn } from '@/design-system/lib/cn';
import type { NotificationIcon as IconKey, NotificationTone } from '@escala/domain/notifications';

const ICONS = {
  send: Send,
  alert: TriangleAlert,
  user: User,
  plane: Plane,
  calendar: CalendarDays,
  swap: ArrowLeftRight,
  cake: CakeSlice,
} as const;

const TONES: Record<NotificationTone, string> = {
  primary: 'bg-primary-soft text-primary',
  danger: 'bg-status-conflict-bg text-status-conflict',
  warning: 'bg-status-partial-bg text-status-partial',
  success: 'bg-status-complete-bg text-status-complete',
};

/** Ícone tingido de uma notificação. */
export default function NotificationIcon({
  icon,
  tone,
  size = 'sm',
}: {
  icon: IconKey;
  tone: NotificationTone;
  size?: 'sm' | 'md';
}) {
  const Icon = ICONS[icon];

  return (
    <span
      aria-hidden
      className={cn(
        'grid shrink-0 place-items-center',
        size === 'sm' ? 'size-8 rounded-control-sm' : 'size-9 rounded-control',
        TONES[tone]
      )}
    >
      <Icon className="size-4 stroke-[1.8]" />
    </span>
  );
}
